import { Component, OnDestroy, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@maersk-global/angular-shared-library';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auth-login',
  standalone: true,
  imports: [],
  template: ``,
  styles: ``
})
export class AuthLoginComponent implements OnDestroy {

  subscription!: Subscription;

  constructor(@Optional() private authenticationService: AuthenticationService, private router: Router, private route: ActivatedRoute) {
    this.subscription = this.route.queryParamMap.subscribe(params => {
      if (!params.has('code')) {
        this.router.navigate(['/']);
      }
    })
  }
  
  ngOnDestroy(): void {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}
